
// Import logo images directly
import logoImgDark from '../assets/logo/advanced-algorithms-logo.svg';
import logoImgLight from '../assets/logo/advanced-algorithms-logo-light.svg';

export const visibilitySetting = false;

export const bannerInfo = {
    title: 'LiDAR Consultants',
    description: 'Experts in LiDAR with an extensive catalog; analysis included.',
};

export const imageData = {
    //logo image - dark version for light mode, light version for dark mode
    logo_img: logoImgLight, // Used in dark mode
    logo_img_light: logoImgDark, // Used in light mode
    //banner image
    banner_img: `${import.meta.env.BASE_URL}img/banner_img.svg`,
    banner_video: `${import.meta.env.BASE_URL}video/shinjuku_2.mp4`,
    banner_video_list: [
        {
            title: 'Shinjuku 2',
            url: `${import.meta.env.BASE_URL}video/shinjuku_2.mp4`,
        },
        {
            title: 'Shinjuku 3',
            url: `${import.meta.env.BASE_URL}video/shinjuku_3.mp4`,
        },
        {
            title: 'Dynamic Places',
            url: `${import.meta.env.BASE_URL}video/dp.mp4`,
        },
    ],

    banner_grid: `${import.meta.env.BASE_URL}img/banner_grid.svg`,

    //welcome section image
    process_img_1: `${import.meta.env.BASE_URL}img/tokyo-station.jpg`,

    //upload section image
    upload_img: `${import.meta.env.BASE_URL}img/upload_img.svg`,
    upload_icon: `${import.meta.env.BASE_URL}img/upload_icon.svg`,
    upload_background: `${import.meta.env.BASE_URL}img/upload_background.svg`,

    //demo section image
    calender_icon: `${import.meta.env.BASE_URL}img/calender_icon.svg`,

    //About us page background and section image
    about_background_img: `${import.meta.env.BASE_URL}img/about_background_img.svg`,
    about_img: `${import.meta.env.BASE_URL}img/about_img.svg`,

    pipeline_img: `${import.meta.env.BASE_URL}img/pipeline_img.png`,

    //Contact us page background and section image
    contact_background_img: `${import.meta.env.BASE_URL}img/contact_background_img.svg`,
    contact_img: `${import.meta.env.BASE_URL}img/contact_img.svg`,

    //LiDAR Atlas menu page scroll redirect to top icon
    scroll_top_icon: `${import.meta.env.BASE_URL}img/scroll_top_icon.svg`,

    //LiDAR Atlas menu page demo section animated arrow image
    direction_arrow_img: `${import.meta.env.BASE_URL}img/direction_arrow_img.svg`,
};

export const menuItems = [
    { label: 'Home', key: 'home', path: '/', visibility: true },
    { label: 'Industries', key: 'industries', path: '/industries', visibility: true },
    { label: 'Solutions', key: 'solutions', path: '/solutions', visibility: true },
    { label: 'Collection', key: 'collection', path: '/collection', visibility: true },
    { label: 'Processing', key: 'processing', path: '/processing', visibility: true },
    { label: 'Get a Quote', key: 'quote', path: '/quote', visibility: true }
];

export const apiEndpoints = {
    // Lambda endpoint for quotation requests
    quotationRequest: 'https://sfdjxraju6k4zqb444lmzozghy0jpkzv.lambda-url.us-west-1.on.aws/',
    // Lambda endpoint for file uploads (pre-signed URLs)
    fileUpload: 'https://3cwnb7llcpdtrt3rtt7wpjdhmm0rxvgb.lambda-url.us-west-1.on.aws/'
};

// File upload configuration
export const uploadConfig = {
    maxFiles: 10,          // Maximum number of files
    maxSizeInMB: 500,      // Maximum file size in MB
    allowedTypes: null,    // null means all types allowed, or specify like ['image/*', 'application/pdf']
};

// Quote types available in the contact request form
export const quoteTypes = [
    'DEM',
    'LiDAR Collect',
    'AUTOMATION',
    'Catalog Order',
    'Telco',
    'Utility',
    'Land Analysis',
    'Vegetation',
    'Government',
    'Other Consulting'
];

